import anime from 'animejs'
import {debounce} from 'throttle-debounce'

export default function nav() {
	const menu = document.querySelector('.main-nav__items'),
		menuBtn = document.querySelector('.main-nav__mob-menu'),
		menuList = document.querySelectorAll('.main-nav__item'),
		menuLinks = document.querySelectorAll('.main-nav__item > .main-nav__link'),
		lastItemLinks = menuList[menuList.length - 1].querySelectorAll('a'),
		menuEl = document.querySelector('.main-nav'),
		menuAnim = mobileMenuTimline()

	clearAnimationStyles(menuAnim, true)


	// Deal with changing screen sizes
	const resizeFunc = debounce(800, () => {
		if(!menuIsMobile()) {
			toggleActive(menuEl, 'main-nav--expanded', false)
			toggleActive(document.body, 'mobile-menu-active', false)
			clearAnimationStyles(menuAnim, true)

			menuLinks.forEach((el) => {
				toggleActive(el.parentNode, 'main-nav__item--active', false)
				el.nextElementSibling.removeAttribute('style')
			})
		}
	})
	window.addEventListener('resize', (e) => {
		resizeFunc()
	}, true)


	// hamburger click
	menuBtn.addEventListener('click', function (event) {
		window.scrollTo(0,0)
		toggleActive(menuEl, 'main-nav--expanded')
		toggleActive(document.body, 'mobile-menu-active')

		anime.remove(menu)

		if(document.body.classList.contains('mobile-menu-active')) {
			menu.style.display = 'flex'
			menuAnim.restart()
		} else {
			menuAnim.reverse()
			// prevent blink
			menuAnim.completed = false
			menuAnim.play()
		}
	})

	menuList.forEach(el => {
		el.addEventListener('mouseenter', function (event) {
			if (!menuIsMobile()) {
				toggleActive(el, 'main-nav__item--active', true)
			}
		})
		el.addEventListener('mouseleave', function (event) {
			if (!menuIsMobile()) toggleActive(el, 'main-nav__item--active', false)
		})
	})

	menuLinks.forEach((el, index) => {
		el.addEventListener('focus', function (event) {
			if (!menuIsMobile()) {
				menuList.forEach(el => {
					toggleActive(el, 'main-nav__item--active', false)
				})

				toggleActive(el.parentNode, 'main-nav__item--active', true)
			}
		})

		// Mobile menu
		el.addEventListener('click', function (event) {
			if (menuIsMobile()) {
				event.preventDefault()
				const dropdown = el.nextElementSibling
				let storeHeight = 0

				dropdown.style.height = 'auto'
				storeHeight = dropdown.offsetHeight

				if(toggleActive(el.parentNode, 'main-nav__item--active')) {
					animHeight(dropdown, 0, storeHeight + 'px')
				} else {
					animHeight(dropdown, storeHeight + 'px', 0)
				}
			}
		})
	})

	lastItemLinks[lastItemLinks.length - 1].addEventListener('keydown', function (event) {
		if (event.keyCode == 9) {
			toggleActive(menuList[menuList.length - 1], 'main-nav__item--active', false)
		}
	})

	function toggleActive(el, cls, show) {
		let clsList = el.classList

		if (typeof show === 'undefined') {
			show = clsList.contains(cls) ? false : true
		}

		if (show) {
			clsList.add(cls)
		} else {
			clsList.remove(cls)
		}

		return show
	}

	function menuIsMobile() {
		return window.innerWidth > 1024 ? false : true
	}

	function animHeight(el, start, end) {
		anime({
			targets: el,
			easing: 'easeOutCubic',
			height: [start, end],
			duration: 250,
			complete: (a) => {
				anime.remove(el)
			}
		})
	}

	function mobileMenuTimline() {
		const menuItems = document.querySelectorAll('.main-nav__items>.main-nav__item'),
			menuSp = document.querySelector('.main-nav__items-special'),
			tl = anime.timeline({
				easing: 'easeInOutCubic',
				duration: 300,
				autoplay: false,
				complete: (a) => {
					if(a.reversed) {
						menu.style.display = 'none'
						a.reverse()
						clearAnimationStyles(a, true)
					}
				},
			})

		tl.add({
			targets: menu,
			opacity: [0, 1]
		})
		.add({
			targets: menuItems,
			opacity: [0, 1],
			translateY: ['-10px', 0]
		})
		.add({
			targets: menuSp,
			opacity: [0,1],
			translateY: ['20px', 0]
		}, '-=100')

		return tl
	}

	function clearAnimationStyles(a, timeline) {
		if(timeline) {
			a.children.forEach((obj) => {
				clearAnimatables(obj)
			})
		} else {
			clearAnimatables(a)
		}

		function clearAnimatables(obj) {
			obj.animatables.forEach((el) => {
				el.target.removeAttribute('style')
			})
		}
	}
}
